import { render, staticRenderFns } from "./MemorandoButton.vue?vue&type=template&id=18a27c86&scoped=true&"
import script from "./MemorandoButton.vue?vue&type=script&lang=js&"
export * from "./MemorandoButton.vue?vue&type=script&lang=js&"
import style0 from "./MemorandoButton.vue?vue&type=style&index=0&id=18a27c86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a27c86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
